module.exports = __webpack_public_path__ + "img/bian.7020d453.png";